import React, { useContext, useEffect, useState } from "react";
import { IToastContext, ToastContext } from "../../../providers/Toast";
import PageHeader from "../../../components/shared/pageHeader/PageHeader";
import { useTranslation } from "react-i18next";
import EventsList from "../../../components/events/list";
import { Event, EventsByDay } from "../../../data/interfaces";
import { getEventsByDay, getEventsCountersByMonth, getNextEvents } from "../../../context/events/action";
import _environment from "../../../_environment/_environment";
import moment from "moment";
import { EVENTS_STATUSES } from "../../../data/enums";
import { useHistory } from "react-router-dom";
import queryString from "query-string";
import DatePicker from "react-datepicker";
import { momentInRome } from "../../../utils/mapping";

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {
}

interface Day {
  date: Date;
  formatted: string;
  timestamp: number | string;
}

const EventsListView = ({ ...restProps }: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------

  const history = useHistory();

  // Access to toast manager hook that you may use to show toasts.
  const { openToast } = useContext<IToastContext>(ToastContext);

  // Access to i18n instance that you may use to translate your content.
  const { t } = useTranslation();

  // Events statuses
  const statuses: { label: string; type: EVENTS_STATUSES }[] = [
    {
      type: EVENTS_STATUSES.STATUS_NEXT,
      label: t("pages.eventsList.filters.status.options.next"),
    },
    {
      type: EVENTS_STATUSES.STATUS_OVER,
      label: t("pages.eventsList.filters.status.options.over"),
    },
  ];

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------

  // Loading
  const [isEventsCountersByMonthLoading, setEventsCountersByMonthLoading] = useState<boolean>(false);
  const [isEventsByDayLoading, setEventsByDayLoading] = useState<boolean>(false);

  // Local array of data
  const [events, setEvents] = useState<Event[]>([]);
  const [filteredEvents, setFilteredEvents] = useState<Event[]>([]);
  const [nextEvents, setNextEvents] = useState<Event[]>([]);

  // Calendar
  const [currentMonth, setCurrentMonth] = useState<number | undefined>(undefined);
  const [currentYear, setCurrentYear] = useState<number | undefined>(undefined);
  const [countersByDay, setCountersByDay] = useState<any>(undefined);
  const [selectedDay, setSelectedDay] = useState<Date | undefined>(undefined);

  // Status (over, next or live)
  const [status, setStatus] = useState<any>(queryString.parse(history.location.search).status);

  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------

  /**
   * Load events from database
   * @function
   *
   * @function
   */
  const loadEvents = async () => {
    // Control required for the linter
    if (!selectedDay) return;

    // Show loading
    setEventsByDayLoading(true);

    try {
      console.log("PASSO")
      setEvents(await getEventsByDay(momentInRome(selectedDay, true).toDate()));

    } catch (err) {
      console.error(err);
      openToast({
        type: "error",
        title: "errors.general.title",
        message: "errors.general.description",
        callback: () => {
        },
      });
    } finally {
      setEventsByDayLoading(false);
    }
  };

  /**
   * Update query string params
   * @function
   *
   * @function
   */
  const updateQueryStringParams = (param: "day" | "status") => {

    let params = queryString.parse(history.location.search);

    switch (param) {
      case "day":
        if (typeof selectedDay !== "undefined") {
          params.day = `${moment(selectedDay).unix()}`;
        }
        break;
      case "status":
        if (typeof status !== "undefined") {
          params.status = `${status}`;
        } else {
          delete params.status;
        }
        break;
    }

    history.push({
      pathname: history.location.pathname,
      search: queryString.stringify(params),
    });
  };

  /**
   * Sort events locally
   * @function
   *
   * @function
   */
  const sortEvents = () => {
    // Set events object property based on selected day
    //const dayEvents = events[moment(selectedDay).format("DDMMYYYY")];

    // Control required for the linter
    //if (!events) return;

    let res: Event[] = [];

    // Sorting events
    const live = events.filter((e: Event) => {
      return moment().isSameOrAfter(moment(e.start_datetime.toDate())) && moment().isSameOrBefore(moment(e.end_datetime.toDate()));
    });
    const next = events.filter((e: Event) => {
      return moment().isBefore(moment(e.start_datetime.toDate()));
    });
    const over = events.filter((e: Event) => {
      return moment().isAfter(moment(e.end_datetime.toDate()));
    });

    res = [...live, ...next, ...over];

    if (typeof status !== "undefined") {
      switch (status) {
        case EVENTS_STATUSES.STATUS_NEXT:
          res = res.filter((e) => {
            let isStarted = moment.unix(e.start_datetime.seconds).isSameOrBefore(moment());
            let isOver = moment.unix(e.end_datetime.seconds).isBefore(moment());

            return !isStarted || (isStarted && !isOver);
          });
          break;
        case EVENTS_STATUSES.STATUS_OVER:
          res = res.filter((e) => {
            return moment.unix(e.end_datetime.seconds).isBefore(moment());
          });
          break;
      }
    }

    // Update filtered events state
    setFilteredEvents(res);
  };

  /**
   * Handle filters from query string
   */
  const updateFiltersByQueryParams = () => {
    // Read queryString filters
    const params = queryString.parse(history.location.search);

    // Validate unix timestamp read from query string day param
    const validateInputDate = (date: moment.Moment): moment.Moment => {
      // If the date is not included in the fair period, use the fair start date or the fair end date
      if (date.isBefore(_environment.fairStartdate)) {
        date = _environment.fairStartdate;
      }
      if (date.isAfter(_environment.fairEndDate)) {
        date = _environment.fairEndDate;
      }
      return date;
    };

    const updateDayFilter = () => {
      // Validate and, if it's valid, use the parameters in query string if they have been
      // specified, otherwise define the default date according to the fair status

      let date: moment.Moment = validateInputDate(!!params.day && params.day !== "undefined"
        ? moment.unix(parseInt(`${params.day}`))
        : moment(selectedDay),
      );

      // Checking if it is a valid date
      if (!date.isValid()) return;


      /*if (!currentMonth) {
        // The current month has not yet been set: set it according to the date read from the query string params
        setCurrentMonth(parseInt(date.format("M")));
        setCurrentYear(parseInt(date.format("YYYY")));
      } else*/
      if (!selectedDay) {
        // The current month has already been set: also set the current day read from the query string params
        setSelectedDay(date.toDate());
      }
    };

    const updateStatusFilter = () => {
      if (params.status) {
        // default
        let res: EVENTS_STATUSES | undefined;

        switch (params.status) {
          case "0":
            res = EVENTS_STATUSES.STATUS_NEXT;
            break;
          case "1":
            res = EVENTS_STATUSES.STATUS_OVER;
            break;
        }
        if (typeof res !== "undefined") {
          setStatus(res);
        }
      }
    };

    updateDayFilter();
    updateStatusFilter();
  };

  // TODO: TESTARE CON UNA TIME ZONE LONTANA

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------
  /**
   * This method is called the first time the component is mounted
   * @function
   */
  const init = (): void => {
    // init component
    console.log("[EventsListView] init");

    updateFiltersByQueryParams();
  };

  /**
   * This method is called when the component is unmounted
   * @function
   */
  const destroy = (): void => {
    // destroy component
    console.log("[EventsListView] destroy");
  };

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This hook is called once when the component is mounted
   */
  useEffect(() => {
    init();

    return () => {
      destroy();
    };
  }, []);

  /**
   * Hook to status in order to apply it
   */
  useEffect(() => {
    updateQueryStringParams("status");
    sortEvents();
  }, [status]);

  /**
   * Hook to currentMonth in order to get counters by day
   */
  /*useEffect(() => {
    // For this month the counter per day has not yet been downloaded
    if (currentMonth && (!countersByDay || !countersByDay.hasOwnProperty(currentMonth))) {
      (async () => {
        // Show loading
        setEventsCountersByMonthLoading(true);

        // Download counter per day of currentMonth
        const eventsCountersByMonth = await getEventsCountersByMonth(moment(`${currentMonth}-${currentYear}`, "M-YYYY").startOf("month").toDate());

        const res: any = {
          [currentMonth]: [],
        };

        if (eventsCountersByMonth.length > 0) {
          eventsCountersByMonth.forEach((e: any) => {
            e.day = moment(e.day.toDate());
            res[currentMonth].push(e);
          });
        }

        setCountersByDay({
          ...countersByDay,
          ...res,
        });
      })();
    } else {
      // First call
      updateFiltersByQueryParams();
    }
  }, [currentMonth]);*/

  /**
   * Hook to selectedDay in order to get events by day
   */
  /*useEffect(() => {
    if (countersByDay) {
      // Hide loading
      setEventsCountersByMonthLoading(false);

      // Update the selected day
      updateFiltersByQueryParams();
    }
  }, [countersByDay]);*/

  /**
   * Hook to selectedDay in order to get events by day
   */
  useEffect(() => {
    if (!!selectedDay) {
      // A day has already been selected
      (async () => {

        // Delete next events in case they were populated because the default day had no events
        if (nextEvents.length > 0) {
          setNextEvents([]);
        }

        // Control required for the linter
        //if (!countersByDay) return;

        // Update query string params
        updateQueryStringParams("day");

        await loadEvents();

        // Check that the selected day is also present in local counters by day data in order to get data only if it's needed
        /*if (countersByDay[moment(selectedDay).format("M")].some((e: EventsByDay) => e.day.format("DD/MM/YYYY") === moment(selectedDay).format("DD/MM/YYYY"))) {
          // Download the events of the day only if they have not already been downloaded previously
          if (!events || !events.hasOwnProperty(moment(selectedDay).format("DDMMYYYY"))) {
            // The events for this day have not been downloaded yet
            await loadEvents();
          } else {
            // The events for this day have already been downloaded: read them
            sortEvents();
          }
        } else {
          // According to the counter per day, there are no events on this day: download the next ones
          // There are no events for this day: download next events
          setNextEvents(await getNextEvents(moment(selectedDay)));
        }*/
      })();
    }
  }, [selectedDay]);

  /**
   * Hook to events in order to update filters
   */
  useEffect(() => {
    if (events.length === 0) {
      (async ()=>{
        setNextEvents(await getNextEvents(moment(selectedDay)));
      })();
    }
    sortEvents();
  }, [events]);

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return (
    <>
      <div className="page-content">
        <div className={"container full-page"}>
          <div className="full-page-image">
            <img src="/assets/images/undraw/video.png" />
          </div>

              <>
                <PageHeader title={t("pages.eventsList.title")} />

                <div className={"column-layout"}>
                  <div className={"left-column"}>

                    <div className={"filter-box"}>
                      <header>
                        <h6 className={"title"}>{t("pages.eventsList.filters.day.title")}</h6>
                      </header>
                      <ul className="events-day-filter">
                        {(isEventsByDayLoading || isEventsCountersByMonthLoading) && (
                          <div className={"layer"}><i className="fas fa-spin fa-spinner" /></div>
                        )}
                        <DatePicker
                          inline
                          selected={selectedDay}
                          minDate={_environment.fairStartdate.toDate()}
                          maxDate={_environment.fairEndDate.toDate()}
                          onChange={(date) => {
                            if (date instanceof Date) {
                              setSelectedDay(date);
                            }
                          }}
                          /*onMonthChange={(date) => {
                            setCurrentMonth(moment(date).month() + 1);
                            setCurrentYear(moment(date).year());
                          }}*/
                          /*highlightDates={countersByDay[currentMonth] && countersByDay[currentMonth].map((counter: EventsByDay) => {
                            return moment(counter.day, "DDMMYYYY").toDate();
                          })}*/
                        />
                      </ul>
                    </div>

                    <div className={"filter-box"}>
                      <header>
                        <h6 className={"title"}>{t("pages.eventsList.filters.status.title")}</h6>
                        {typeof status !== "undefined" && (
                          <a className={"clear"}
                             onClick={() => {
                               setStatus(undefined);
                               updateQueryStringParams("status");
                             }}
                          >{t("pages.eventsList.filters.clear")}</a>
                        )}
                      </header>
                      <ul className="events-type-filters">
                        {statuses.map((s) => (
                          <li
                            key={s.type}
                            onClick={() => setStatus(s.type)}
                            className={`${s.type === status ? "active" : ""}`}
                          >
                            <a>{s.label}</a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div className={"center-column"}>

                    <div className={"pl-4"}>
                      <div className="events-header mb-4">
                        <h3 className="mb-0">{moment(selectedDay).format("dddd MMMM, Do")}</h3>
                      </div>

                      <div className={`events-list ${filteredEvents.length === 0 ? "no-data" : ""}`}>
                        {!!filteredEvents && filteredEvents.length > 0 && (
                          <EventsList events={filteredEvents} />
                        )}
                      </div>

                      {/* No data */}
                      {!isEventsCountersByMonthLoading && !isEventsByDayLoading && (!filteredEvents || !filteredEvents.length) && (
                        <>
                          <p>{t(`pages.eventsList.${nextEvents && nextEvents.length > 0 ? "noData" : "noFilteredData"}`)}</p>
                          {nextEvents && nextEvents.length > 0 && (
                            <>
                              <h3 className="mt-5 mb-4">{t("pages.eventsList.nextEvents")}</h3>
                              <EventsList events={nextEvents} />
                            </>
                          )}
                        </>
                      )}
                    </div>

                  </div>
                </div>
              </>
        </div>
      </div>
    </>
  );
};
export default EventsListView;
